import SkeletonElement from "./SkeletonElement";
import SkeletonShimmer from "./SkeletonShimmer";

const SkeletonPROPage = () => {
  return (
    <>
      <div className="" style={{ marginTop: "128px" }}></div>
      <div className="skeleton-wrapper">
        <SkeletonElement type="title" />
        <SkeletonElement type="text" />
        <SkeletonElement type="text" />
        <SkeletonElement type="text" />
        <SkeletonShimmer />
      </div>
      <div className="skeleton-wrapper">
        <SkeletonElement type="title" />
        <SkeletonElement type="text" />
        <SkeletonElement type="text" />
        <SkeletonElement type="text" />
        <SkeletonShimmer />
      </div>
      <div className="skeleton-wrapper">
        <SkeletonElement type="title" />
        <SkeletonElement type="text" />
        <SkeletonElement type="text" />
        <SkeletonElement type="text" />
        <SkeletonShimmer />
      </div>
    </>
  );
};

export default SkeletonPROPage;
